<template>
  <div>
    <div id="func-content">
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="p-4 box-shadow">
              <div class="row mt-3">
                <label class="control-label col-md-3">品牌：</label>
                    <div class="col-md-3">
                       <select
                          id="queryBrandsCode"
                          name="queryBrandsCode"
                          class="form-control"
                          v-model="search.queryBrandsCode"
                        >
                        <option
                          v-for="x in selectListBrands"
                          v-bind:value="x.Code"
                          :key="x.Code"
                        >{{x.Text}}</option>
                        </select>
                    </div>
                <label class="control-label col-md-3">店號：</label>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search.code"
                    placeholder="請輸入店號"
                  />
                </div>
              </div>
              <div class="row mt-3">
                  <label class="control-label col-md-3">店名：</label>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search.name"
                    placeholder="模糊搜尋"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <label class="control-label col-md-3">APP顯示文字：</label>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search.memo"
                    placeholder="模糊搜尋"
                  />
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-3" style="text-align:right">
                  <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                  <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-6">
                <h3></h3>
              </div>
              <div class="col-lg-12 mt-2">
                <div class="table-responsive">
                  <table class="table table-bordred table-striped">
                    <thead>
                      <tr>
                        <th>項次</th>
                        <th>品牌</th>
                        <th>店號</th>
                        <th>店名</th>
                        <th>固定店休日</th>
                        <th>APP顯示文字</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                        <td>
                          {{ pageRows * (search.currentPage - 1) + index + 1 }}
                        </td>
                        <td>{{x.BrandCode}}</td>
                        <td>{{ x.Code }}</td>
                        <td>{{ x.Name }}</td>
                        <td v-show="x.PublicHoliday == '0'">無</td>
                        <td v-show="x.PublicHoliday == '1'">一</td>
                        <td v-show="x.PublicHoliday == '2'">二</td>
                        <td v-show="x.PublicHoliday == '3'">三</td>
                        <td v-show="x.PublicHoliday == '4'">四</td>
                        <td v-show="x.PublicHoliday == '5'">五</td>
                        <td v-show="x.PublicHoliday == '6'">六</td>
                        <td v-show="x.PublicHoliday == '7'">日</td>
                        <td>{{ x.Memo }}</td>
                        <td>
                          <button v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" @click="showEdit(x)">
                            <span class="fa fa-pencil-alt" v-if="FunctionPermission > 1"></span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination
                    size="md"
                    :total-rows="totalRows"
                    v-model="search.currentPage"
                    :per-page="pageRows"
                    @change="changePage"
                  ></b-pagination>
                  <label style="margin: 8px"
                    >{{ startRowNum }}到{{ endRowNum }}，總共
                    {{ totalRows }}筆</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <!-- 編輯畫面Modal -->
      <b-modal ref="mdEdit" hide-footer no-close-on-backdrop size='lg' title='編輯'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-3'>
                <label class='control-label col-md-3'>品牌：</label>
                  <div class='col-md-7'>
                    {{md_item.BrandCode}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>店號：</label>
                  <div class='col-md-7'>
                    {{md_item.Code}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>店名：</label>
                  <div class='col-md-7'>
                    {{md_item.Name}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>固定店休：</label>
                  <div class='col-md-7'>
                    <select id='Input_TicketRule' name='Input_TicketRule' class='form-control' @change="weekMsg()" v-model='md_item.PublicHoliday'>
                        <option value='0'>無</option>
                        <option value='1'>一</option>
                        <option value='2'>二</option>
                        <option value='3'>三</option>
                        <option value='4'>四</option>
                        <option value='5'>五</option>
                        <option value='6'>六</option>
                        <option value='7'>日</option>
                    </select>
                    <div class="text-danger" v-if="valid_WeekMsg">{{valid_WeekMsg}}</div>
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>APP顯示文字：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.Memo' placeholder='建議不超過四個中文字' maxlength="15" >
                  </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row float-right cog-lg-12">
                  <b-btn variant="primary"  @click="editCheck()">儲存</b-btn>&nbsp;
                  <b-btn variant="secondary"  @click="editCancel()">取消</b-btn>&nbsp;
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <b-modal ref="mdCancelCheck" hide-footer title="取消訂單提醒">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">提醒您，<br />修改固定店休為當日，訂單須由人員手動執行退貨，<br />
                修改固定店休為非當日，訂單由系統執行自動取消，共<font style="color:red">{{cancelCount}}</font>筆。<br />確定要修改固定店休日 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="editConfirm()">確定</b-btn>
              <b-btn variant="secondary" @click="closeCancelCheck()">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>
import { getFunctionPermission } from "../../../js/LoginUserFunction.js";
import { API_URL } from "../../../store/root.js";
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import miniToastr from "mini-toastr";
import axios from "axios";

miniToastr.init();
export default {
  data() {
    return {
      search: {
        code: "",
        name: "",
        memo: "",
        currentPage: 1,
        queryBrandsCode: DEFAULT_SEARCH_BRAND_CODE,
      },
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      md_id: 0,
      md_title: "",
      md_originalWeek: "",
      valid_WeekMsg: "",
      md_item: {
        ID: 0,
        Code: "",
        Name: "",
        PublicHoliday: "0",
        Memo: "",
        BrandCode: ""
      },
      API_URL: API_URL,
      FunctionPermission: 0,
      cancelCount: 0,
      selectListBrands: []
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F34"); // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: "name" });
      return;
    }

    var search = this.$route.params.search;
    if (search !== undefined) {
      this.search = search;
      console.log(this.search);
      this.query();
    } else {
      this.reset();
    }
  },
  methods: {
    turnWeek(week) {
      if (week == "1") {
        return "一";
      } else if (week == "2") {
        return "二";
      } else if (week == "3") {
        return "三";
      } else if (week == "4") {
        return "四";
      } else if (week == "5") {
        return "五";
      } else if (week == "6") {
        return "六";
      } else if (week == "7") {
        return "日";
      } else {
        return "";
      }
    },
    weekMsg (){
      if (this.md_originalWeek !== "0") {
        var str = this.turnWeek(this.md_originalWeek)
        if (this.md_item.PublicHoliday == this.md_originalWeek) {
          this.valid_WeekMsg = "";
        } else {
          this.valid_WeekMsg = "注意！變更後，系統日(含)後的週"+str+"店休將被移除";
        }
      }
    },
    reset() {
      this.search.code = "";
      this.search.name = "";
      this.search.memo = "";
      this.search.currentPage = 1;
      this.search.queryBrandsCode = DEFAULT_SEARCH_BRAND_CODE

      this.query();
    },
    btnQuery() {
      this.search.currentPage = 1;
      this.query();
    },
    query() {
      this.querySelectListBrands()
      var name, code, memo, page, pageRows, brandCode;

      name = this.search.name;
      code = this.search.code;
      memo = this.search.memo;
      page = this.search.currentPage;
      pageRows = this.pageRows;
      brandCode = this.search.queryBrandsCode

      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/shopping/getPageStorePublicHoliday", {
          code: code,
          name: name,
          memo: memo,
          page: page,
          pageRows: pageRows,
          brandCode: brandCode
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.items = response.data.data;
            this.totalRows =
              response.data.count === undefined ? 0 : response.data.count;
            this.search.currentPage = page; // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum =
              response.data.count === undefined || response.data.count === 0
                ? 0
                : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum =
              response.data.count === undefined || response.data.count === 0
                ? 0
                : this.pageRows > response.data.count
                ? response.data.count
                : this.search.currentPage * this.pageRows >= response.data.count
                ? response.data.count
                : this.search.currentPage * this.pageRows;
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.items = [];
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    changePage(page) {
      this.search.currentPage = page;
      this.query();
    },
    showEdit(item) {
      this.md_item.ID = item.ID;
      this.md_item.Code = item.Code;
      this.md_item.Name = item.Name;
      this.md_item.PublicHoliday = item.PublicHoliday;
      this.md_item.Memo = item.Memo;
      this.md_originalWeek = item.PublicHoliday;
      this.md_item.BrandCode = item.BrandCode
      this.valid_WeekMsg = "";
      this.$refs.mdEdit.show();
    },
    editCheck() {
      this.$refs.mdCancelCheck.show();
      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/shopping/StorePublicHoliday/GetWillOrderCancelCount", {
          id: this.md_item.ID,
          holiday: this.md_item.PublicHoliday,
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.cancelCount = response.data.count;
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "資料變更錯誤");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.$parent.Loading = false;
          miniToastr.error(error, "資料變更錯誤");
          console.log(error);
        });
    },
    editConfirm() {
      this.$parent.Loading = true;
      this.$refs.mdCancelCheck.hide();
      return axios
        .post(API_URL + "/web/shopping/StorePublicHolidayUpdate", {
          id: this.md_item.ID,
          holiday: this.md_item.PublicHoliday,
          memo: this.md_item.Memo,
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            miniToastr.success("修改成功");
            this.$refs.mdEdit.hide();
            this.query();
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "資料變更錯誤");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.$parent.Loading = false;
          miniToastr.error(error, "資料變更錯誤");
          console.log(error);
        });
    },
    editCancel() {
      this.$refs.mdEdit.hide();
    },
    closeCancelCheck() {
      this.$refs.mdCancelCheck.hide();
    },
    querySelectListBrands() {
      axios.post(API_URL + "/web/brands/v1", {
        all: false,
        status: 0
      })
  
      .then(response => {
        this.selectListBrands = response.data.data;
        this.$parent.Loading = false;
        })
  
      .catch(error => {
        this.selectListBrands = [];
        this.$parent.Loading = false;
        miniToastr.error(error, "資料讀取異常");
        console.log(error);
      })
    }
  },
};
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move > tbody > tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 270px;
}
.active {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/storeholiday/PublicHoliday.vue